import React, { useEffect, useState } from "react";
import { Aboutsec1, Aboutsec2 } from "./components/Aboutcomponent";
import { Sec2, Sec3, Sec5 } from "./components/Homecomponent";
import PageHeader from "./components/PagesHeaderComponent/PageHeader";
import regulationImg from "../assets/images/regulations.png"
import notificationImg from "../assets/images/notification.png"
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom/dist";
import PageHeaderWithRoutes from "./components/PagesHeaderComponent/PageHeaderWithRoute";
import RegulatoryIcon from "../assets/images/icons/regulatory_info_icon.png"
import ResourceIcon from "../assets/images/icons/useful_resource_icon.png"
import NewsFeedIcon from "../assets/images/icons/newsfeed_icon.png"
import InnerHeading from "./components/InnerHeading/InnerHeading";
import CoreHttpHandler from "../http/services/CoreHttpHandler";
import { Box, LinearProgress } from "@mui/material";
import { Pagination } from "antd";
import ReportIcon from "../assets/images/icons/report.png"

const UsefulResources = () => {

	const navigate = useNavigate();
	const [categories, setCategories] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [totalRecords, setTotalRecords] = useState(0);
	const [currentPage, setCurrentPage] = useState(0);

	const getCategories = (limit, page) => {
		setIsLoading(true)
		CoreHttpHandler.request(
			"library",
			"fetchPostCategories",
			{
				"category_nav_id": 2,
				"limit": limit || 6,
				"page": page || 1
			},
			(res) => {
				setCategories(res.data.data.postCategories?.post_categories)
				setTotalRecords(res?.data?.data?.postCategories.pagination.totalRecords)
				setCurrentPage(res?.data?.data?.postCategories.pagination.page)
				setIsLoading(false)
				// ToastAlertSuccess("Item removed Successfully");
			},
			(err) => {
				// ToastAlertError(
				// 	err?.response?.data?.message
				// 		? err?.response.data.message
				// 		: "something went wrong"
				// );
			}
		);
	};


	const handleBtnClick = (data) => {
		navigate(`/Library/UsefulResources/${encodeURIComponent(data.name)}`, {
			state: {
				...data,
			},
		});
	}

	let headerData = [{
		name: "Regulatory Information",
		route: "/Library/Legal&RegulatoryInformation",
		imgSrc: RegulatoryIcon
	}, {
		name: "Resources",
		route: "/Library/UsefulResources",
		imgSrc: ResourceIcon
	}, {
		name: "News Feed",
		route: "/Library/NewsFeeds",
		imgSrc: NewsFeedIcon

	}, {
		name: "Reports",
		route: "/Library/UsefulResources/REPORTS",
		imgSrc: ReportIcon

	}
	]

	useEffect(() => {
		getCategories();
	}, [])

	return (
		<>
			<PageHeaderWithRoutes tabs={headerData} heading="Corporate Governance Library" desc="Discover our comprehensive library—a vital resource hub of legal and regulatory information, resources, and news essential for shareholders. Explore our extensive repository to stay informed with the latest updates and news feeds relevant to corporate governance." />

			{/* <PageHeader heading="Information Repository" /> */}
			<div className="content_wrap">
				<div className="library">
					<section className='sec sec2'>

						<div className='container'>
							<div>
								<Container>
									<Row>
										<InnerHeading heading="Resources" text="Access a wealth of invaluable information to empower shareholders with informed decision-making." />

										{isLoading ?
											<Box sx={{ my: '5rem' }}>
												<LinearProgress color="success" />
											</Box>
											:
											categories.map((e,i) => {
												return <>
													<Col lg={4} md={6} key={i}>
														<Card className="legalnRegcards">
															<div className="img_box">
																<img variant="top" src={e.image} />
															</div>
															<h4>{e.name}</h4>
															<Button className="card_btn" onClick={() => handleBtnClick(e)} variant="primary">Read More</Button>
														</Card>
													</Col>
												</>
											})
										}
									</Row>
								</Container>
								<Pagination
									total={totalRecords}
									current={currentPage}
									pageSize={6}
									hideOnSinglePage
									onChange={(e) => {
										getCategories(6, e)
									}} />
							</div>

						</div>
					</section>

				</div>
			</div>
		</>
	);
};

export default UsefulResources;
